import React from 'react'
import { SearchDropdown, Flex, HighlightedText } from '@ui'
import { INeighborhoodTableRecord } from '@api'
import useNeighborhoodsSearch from './hooks/useNeighborhoodsSearch'
import track from '@track'
import Event from '@track/Event'
import css from './neighborhoodDetailsDialog.module.scss'

export default function NeighborhoodSearch({
  navigate,
  queryTable,
}: {
  navigate?: (to: string) => void
  queryTable: (query: string) => void
}) {
  const search = useNeighborhoodsSearch()
  const onSelect = (neighborhood: INeighborhoodTableRecord) => {
    navigate?.(`?neighborhoodId=${neighborhood.id}`)
    track.neighborhoods({
      eventName: Event.SEARCH_RESULT_CLICK,
    })
  }

  return (
    <SearchDropdown
      {...{
        'data-input': 'neighborhood_search',
        search,
        queryTable,
        inputPlaceholder: 'Search by neighborhood name',
        onSelect,
        width: '400px',
      }}
      renderItem={(neighborhood: INeighborhoodTableRecord) => (
        <NeighborhoodItem
          name={neighborhood.name}
          color={neighborhood.color}
          search={search.query}
        />
      )}
    />
  )
}

export function NeighborhoodItem({
  name,
  color,
  search,
}: {
  name: string
  color: string
  search?: string
}) {
  return (
    <Flex data-item={name} align="center">
      <div className={css.square} style={{ backgroundColor: `#${color}` }} />
      <div>
        <div
          className={css.neighborhood_name}
          style={{ lineHeight: '15px', fontSize: 14, color: 'var(--black)' }}
        >
          <HighlightedText text={name} query={search} />
        </div>
      </div>
    </Flex>
  )
}
